module.exports = "https://tutorchat.chegg.com/static/media/ic-shape.dc3c35e8.svg";